<template>
  <svg
    class="w-3"
    width="13"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="8.35718" y="0.5" rx="2" width="5.14286" height="15" fill="currentcolor" />
    <rect x="0.5" y="0.5" rx="2" width="5.14286" height="15" fill="currentcolor" />
  </svg>
</template>
